import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './en';
import { ru } from './ru';

export const UI_LANGUAGES = ['ru', 'en'] as const;
export type UiLanguage = (typeof UI_LANGUAGES)[number];

const STORAGE_KEY = 'shop.admin.lang';

function initialLanguage(): UiLanguage {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'ru' || saved === 'en') return saved;
  } catch {
    // Хранилище недоступно (приватный режим) — язык по умолчанию.
  }
  return navigator.language.startsWith('ru') ? 'ru' : 'en';
}

export function setUiLanguage(lang: UiLanguage): void {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // см. выше
  }
}

void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnNull: false,
});
document.documentElement.lang = i18n.language;

export default i18n;
